import React from 'react';
import MaxturnosHero from '../components/Hero';

const MaxturnosHome = () => {
  return (
    <div className="maxturnos-home">
      <MaxturnosHero />
    </div>
  );
};

export default MaxturnosHome;
